import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get GrnInvoice
export const getGrnInvoice = createAsyncThunk("grnInvoice/getGrnInvoice", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;
  try {
    const { data } = await API.getGrnInvoice({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all GrnInvoice
export const getAllGrnInvoice = createAsyncThunk("grnInvoice/getAllGrnInvoice", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllGrnInvoice();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("grnInvoice/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("grnInvoice/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "grnInvoice/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;
    try {
      const { data } = await API.getPageGrnInvoice({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);

// get PurchaseOrder AdditionalCharge List
export const getAdditionalCostList = createAsyncThunk(
  "grnInvoice/getAdditionalCostList",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await API.getAdditionalCostList();
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get item by id
export const getGrnInvoiceById = createAsyncThunk("grnInvoice/getGrnInvoiceById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getGrnInvoiceById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get item by id
export const getGrnDetailById = createAsyncThunk("grnInvoice/getGrnDetailById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getGrnDetailById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create GrnInvoice
export const createGrnInvoice = createAsyncThunk("grnInvoice/createGrnInvoice", async (data, { rejectWithValue }) => {
  const {
    name,
    grnAdditionalInvoiceDetails,

    grnInvoiceNumber,
    partyInvoiceNo,
    voucherDateBs,
    voucherDate,
    // voucherNumber, donot send field
    refVoucher,
    termsOfDelivery,
    destination,
    deliveryThrough,

    ppnNumber,
    lcNumber,
    lcDate,
    ppDate,
    gateInwardsNo,
    gateInwardDate,
    billDate,
    billNo,
    bulityDate,
    bulityNo,
    branch,
    purchaseOrderMain,
    partyAccount,
    termsOfDeliveryPayment,
    goodReceiptNotesMain,
  } = data;
  try {
    const body = JSON.stringify({
      name,
      grnAdditionalInvoiceDetails,
      grnInvoiceNumber,
      partyInvoiceNo,

      voucherDateBs,
      voucherDate,
      // voucherNumber,
      refVoucher,
      termsOfDelivery,
      destination,
      deliveryThrough,

      ppnNumber,
      lcNumber,
      lcDate,
      ppDate,
      gateInwardsNo,
      gateInwardDate,
      billDate,
      billNo,
      bulityDate,
      bulityNo,
      branch,
      purchaseOrderMain,
      partyAccount,
      termsOfDeliveryPayment,
      goodReceiptNotesMain,
    });
    const { data } = await API.createGrnInvoice(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateGrnInvoice = createAsyncThunk("grnInvoice/updateGrnInvoice", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const {
    name,
    grnAdditionalInvoiceDetails,

    grnInvoiceNumber,
    partyInvoiceNo,
    voucherDateBs,
    voucherDate,
    // voucherNumber, donot send field
    refVoucher,
    termsOfDelivery,
    destination,
    deliveryThrough,

    ppnNumber,
    lcNumber,
    lcDate,
    ppDate,
    gateInwardsNo,
    gateInwardDate,
    billDate,
    billNo,
    bulityDate,
    bulityNo,
    branch,
    purchaseOrderMain,
    partyAccount,
    termsOfDeliveryPayment,
    goodReceiptNotesMain,
  } = values;
  try {
    const body = JSON.stringify({
      name,
      grnAdditionalInvoiceDetails,
      grnInvoiceNumber,
      partyInvoiceNo,

      voucherDateBs,
      voucherDate,
      // voucherNumber,
      refVoucher,
      termsOfDelivery,
      destination,
      deliveryThrough,

      ppnNumber,
      lcNumber,
      ppDate,
      lcDate,
      gateInwardsNo,
      gateInwardDate,
      billDate,
      billNo,
      bulityDate,
      bulityNo,
      branch,
      purchaseOrderMain,
      partyAccount,
      termsOfDeliveryPayment,
      goodReceiptNotesMain,
    });
    const { data } = await API.updateGrnInvoice(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("grnInvoice/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
